import React, { Component } from 'react'
import { connect } from 'react-redux'
import ResetPassword from './ResetPassword'
import * as actions from './actions'
import { isActivate, isPassword, parseQuery } from '../../lib'

class ResetPasswordContainer extends Component {
  componentDidMount () {
    const queries = parseQuery(this.props.location.search)
    const {email, token, old_email} = queries
    if (isActivate(this.props.location.pathname)) {
      this.props
        .checkActivation(email, token)
        .then(res => {
          if (res.status && res.status === 'success') {
            this.props.activateUser(email, token)
          } else if (res.errors) {
            this.props.receiveValidation()
            this.props.linkExpired(true)
          }
        })
        .catch(e => {
          console.error(e)
          
        })
    } else if (isPassword(this.props.location.pathname)) {
      this.props.checkPassword(email, token)
      console.log('isPassword')
    } else {
      console.log('checkEmailChange')
      this.props.checkChangeEmail(old_email, token)
        .then(res => {
          if (res.status && res.status === 'success') {
            this.props.changeEmail(old_email, token)
          } else if (res.errors) {
            this.props.receiveValidation()
            this.props.linkExpired(true)
          }
        })
        .catch(e => {
          console.error(e)
          
        })
    }
  }

  render () {
    return <ResetPassword {...this.props} />
  }
}

const mapStateToProps = (state, ownProps) => ({
  isValidating: state.reset.isValidating,
  isUpdating: state.reset.isUpdating,
  expired: state.reset.expired,
  resetSuccess: state.reset.resetSuccess,
  error: state.reset.error,
  ...ownProps
})

const mapDispatchToProps = dispatch => ({
  changePassword: (authToken, email, password, token) =>
    dispatch(actions.changePassword(authToken, email, password, token)),
  changeEmail: (email, token) =>
    dispatch(actions.changeEmail(email, token)),
  checkChangeEmail: (email, token) =>
    dispatch(actions.checkChangeEmail(email, token)),
  checkActivation: (email, token) =>
    dispatch(actions.checkActivation(email, token)),
  checkPassword: (email, token) =>
    dispatch(actions.checkPassword(email, token)),
  activateUser: (email, token) => dispatch(actions.activateUser(email, token)),
  linkExpired: bool => dispatch(actions.linkExpired(bool)),
  receiveValidation: () => dispatch(actions.receiveValidation())
})

export default connect(mapStateToProps, mapDispatchToProps)(
  ResetPasswordContainer
)



// WEBPACK FOOTER //
// src/routes/ResetPassword/ResetPasswordContainer.js